module.exports = __webpack_public_path__ + "static/img/bak1.c94535c.png";


//////////////////
// WEBPACK FOOTER
// ./static/ing1/bak1.png
// module id = v4Tn
// module chunks = 0